export function scsForms(){
        //******FORMS*********
    /**
     * below is the list of SCS forms. You will need a hidden field at the bottom of the gravity form.
     * In order to add a form below, use the same syntax below and you will need to input the form number,
     * the number for the hidden ga field (gaID), and the number of the hidden ga_campaign_medium (gaMedID)
     */

    // !!! DEV FORM MAPPING !!!
     var formsDev = [
        {
            //Form 1 [0] Coating Service Request Form
            form: 118,
            gaID: 0,
            utmSource: 18,
            utmMedium: 19,
            utmCampaign: 20,
            utmContent: 21,
            utmTerm: 22,
            gClickID: 23,
            dClickID: 24,
        },
        {
            // Form 3 [1] Contact
            form: 3,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 11 [2] Email Signup
            form: 11,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 24 [2] Email Signup CN
            form: 24,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 15 [2] Email Signup DE
            form: 15,
            gaID: 20,
            utmSource: 22,
            utmMedium: 23,
            utmCampaign: 24,
            utmContent: 25,
            utmTerm: 26,
            gClickID: 27,
            dClickID: 28,
        },
        {
            //FORM 17 [2] Email Signup JA
            form: 133,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 2 [3] Engineering Run Request
            form: 2,
            gaID: 19,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 9 [4] Equipment Contact Form
            form: 9,
            gaID: 29,
            utmSource: 34,
            utmMedium: 35,
            utmCampaign: 36,
            utmContent: 37,
            utmTerm: 38,
            gClickID: 39,
            dClickID: 40,
        },
        {
            // FORM 8 [6] Parylene Coatings Form
            form: 8,
            gaID: 63,
            utmSource: 68,
            utmMedium: 69,
            utmCampaign: 70,
            utmContent: 71,
            utmTerm: 72,
            gClickID: 73,
            dClickID: 74,
        },
        {
            // FORM 23 [6] Parylene Coatings Form CN
            form: 23,
            gaID: 63,
            utmSource: 68,
            utmMedium: 69,
            utmCampaign: 70,
            utmContent: 71,
            utmTerm: 72,
            gClickID: 73,
            dClickID: 74,
        },
        {
            // FORM 16 [6] Parylene Coatings Form DE
            form: 16,
            gaID: 63,
            utmSource: 70,
            utmMedium: 71,
            utmCampaign: 72,
            utmContent: 73,
            utmTerm: 74,
            gClickID: 75,
            dClickID: 76,
        },
        {
            // FORM 18 [6] Parylene Coatings Form JA
            form: 18,
            gaID: 63,
            utmSource: 67,
            utmMedium: 68,
            utmCampaign: 69,
            utmContent: 70,
            utmTerm: 71,
            gClickID: 72,
            dClickID: 73,
        },
        {
            // FORM 6 [7] Quote Request
            form: 6,
            gaID: 29,
            utmSource: 32,
            utmMedium: 33,
            utmCampaign: 34,
            utmContent: 35,
            utmTerm: 36,
            gClickID: 37,
            dClickID: 38,
        },
        {
            // FORM 5 [8] Registration Form
            form: 5,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 22 [8] Registration Form CN
            form: 22,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 19 [8] Registration Form DE
            form: 19,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 20 [8] Registration Form JA
            form: 20,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 7 [9] Seminar Registration
            form: 7,
            gaID: 14,
            utmSource: 16,
            utmMedium: 17,
            utmCampaign: 18,
            utmContent: 19,
            utmTerm: 20,
            gClickID: 21,
            dClickID: 22,
        },
        {
            // FORM 12 [10] Seminar Registration Form
            form: 12,
            gaID: 18,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 4 [11] Technical Support
            form: 4,
            gaID: 14,
            utmSource: 17,
            utmMedium: 18,
            utmCampaign: 19,
            utmContent: 20,
            utmTerm: 21,
            gClickID: 22,
            dClickID: 23,
        },
        {
            // FORM 13 [12] Ebook Form
            form: 13,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 14 [13] Parylene Protect
            form: 14,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 25 [14] UAV Ebook Form
            form: 25,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 29 [14] UAV Ebook Form - DE
            form: 146,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 30 [14] UAV Ebook Form - JA
            form: 144,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 31 [14] Waterproofing Ebook Form - DE
            form: 147,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 32 [14] Waterproofing Ebook Form - JA
            form: 145,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        }

    ];

    // !!! PROD FORM MAPPING !!!
    var forms = [
        {
            //Form 1 [0] Coating Service Request Form
            form: 118,
            gaID: 0,
            utmSource: 18,
            utmMedium: 19,
            utmCampaign: 20,
            utmContent: 21,
            utmTerm: 22,
            gClickID: 23,
            dClickID: 24,
        },
        {
            // Form 3 [1] Contact
            form: 120,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 11 [2] Email Signup
            form: 127,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 24 [2] Email Signup CN
            form: 139,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 15 [2] Email Signup DE
            form: 131,
            gaID: 20,
            utmSource: 22,
            utmMedium: 23,
            utmCampaign: 24,
            utmContent: 25,
            utmTerm: 26,
            gClickID: 27,
            dClickID: 28,
        },
        {
            //FORM 17 [2] Email Signup JA
            form: 133,
            gaID: 20,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 2 [3] Engineering Run Request
            form: 119,
            gaID: 19,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 9 [4] Equipment Contact Form
            form: 126,
            gaID: 29,
            utmSource: 34,
            utmMedium: 35,
            utmCampaign: 36,
            utmContent: 37,
            utmTerm: 38,
            gClickID: 39,
            dClickID: 40,
        },
        {
            // FORM 8 [6] Parylene Coatings Form
            form: 125,
            gaID: 63,
            utmSource: 68,
            utmMedium: 69,
            utmCampaign: 70,
            utmContent: 71,
            utmTerm: 72,
            gClickID: 73,
            dClickID: 74,
        },
        {
            // FORM 23 [6] Parylene Coatings Form CN
            form: 138,
            gaID: 63,
            utmSource: 68,
            utmMedium: 69,
            utmCampaign: 70,
            utmContent: 71,
            utmTerm: 72,
            gClickID: 73,
            dClickID: 74,
        },
        {
            // FORM 16 [6] Parylene Coatings Form DE
            form: 132,
            gaID: 63,
            utmSource: 70,
            utmMedium: 71,
            utmCampaign: 72,
            utmContent: 73,
            utmTerm: 74,
            gClickID: 75,
            dClickID: 76,
        },
        {
            // FORM 18 [6] Parylene Coatings Form JA
            form: 134,
            gaID: 63,
            utmSource: 67,
            utmMedium: 68,
            utmCampaign: 69,
            utmContent: 70,
            utmTerm: 71,
            gClickID: 72,
            dClickID: 73,
        },
        {
            // FORM 6 [7] Quote Request
            form: 123,
            gaID: 29,
            utmSource: 32,
            utmMedium: 33,
            utmCampaign: 34,
            utmContent: 35,
            utmTerm: 36,
            gClickID: 37,
            dClickID: 38,
        },
        {
            // FORM 5 [8] Registration Form
            form: 122,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 22 [8] Registration Form CN
            form: 137,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 19 [8] Registration Form DE
            form: 135,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 20 [8] Registration Form JA
            form: 136,
            gaID: 27,
            utmSource: 31,
            utmMedium: 32,
            utmCampaign: 33,
            utmContent: 34,
            utmTerm: 35,
            gClickID: 36,
            dClickID: 37,
        },
        {
            // FORM 7 [9] Seminar Registration
            form: 124,
            gaID: 14,
            utmSource: 16,
            utmMedium: 17,
            utmCampaign: 18,
            utmContent: 19,
            utmTerm: 20,
            gClickID: 21,
            dClickID: 22,
        },
        {
            // FORM 12 [10] Seminar Registration Form
            form: 128,
            gaID: 18,
            utmSource: 21,
            utmMedium: 22,
            utmCampaign: 23,
            utmContent: 24,
            utmTerm: 25,
            gClickID: 26,
            dClickID: 27,
        },
        {
            // FORM 4 [11] Technical Support
            form: 121,
            gaID: 14,
            utmSource: 17,
            utmMedium: 18,
            utmCampaign: 19,
            utmContent: 20,
            utmTerm: 21,
            gClickID: 22,
            dClickID: 23,
        },
        {
            // FORM 13 [12] Ebook Form
            form: 129,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 14 [13] Parylene Protect
            form: 130,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 25 [14] UAV Ebook Form
            form: 140,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 26 [14] EV Ebook Form
            form: 141,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 27 [14] EV DE Ebook Form
            form: 142,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 28 [14] EV JA Ebook Form
            form: 143,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 29 [14] UAV Ebook Form - DE
            form: 146,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 30 [14] UAV Ebook Form - JA
            form: 144,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 31 [14] Waterproofing Ebook Form - DE
            form: 147,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        },
        {
            // FORM 32 [14] Waterproofing Ebook Form - JA
            form: 145,
            gaID: 20,
            utmSource: 42,
            utmMedium: 43,
            utmCampaign: 44,
            utmContent: 45,
            utmTerm: 46,
            gClickID: 47,
            dClickID: 48,
        }
    ];

    //console.log(SCS_ENV);
    var formMap = (SCS_ENV == 'dev') ? formsDev : forms;

    jQuery(document).on('gform_post_render', function(){
        scs_update_fields(formMap);
    });


    jQuery(window).on('load',function(){
        scs_update_fields(formMap);
    })

    console.log(SCS_ENV ? SCS_ENV : 'prod');
    console.log(formMap);
}



/***  SCS helper functions ***/

function scs_update_fields(forms){
    const gforms = document.querySelectorAll('form[id*="gform_"]');

    for(let i = 0; i < gforms.length; i++){
        const formId = gforms[i].getAttribute('id');
        let formNum = formId.split('_');
        formNum = formNum[1];

        const formObj = forms.filter((item) => {
            return item.form == formNum;
        })[0];

        if(formObj){
            scs_update_formfields_cookie(formObj.form, formObj.gaID, "_ga");
            scs_update_formfields_cookie(formObj.form, formObj.utmSource, "__utmzz", "utmcsr");
            scs_update_formfields_cookie(formObj.form, formObj.utmMedium, "__utmzz", "utmcmd");
            scs_update_formfields_cookie(formObj.form, formObj.utmCampaign, "__utmzz", "utmccn");
            scs_update_formfields_cookie(formObj.form, formObj.utmContent, "__utmzz", "utmcct");
            scs_update_formfields_cookie(formObj.form, formObj.utmTerm, "__utmzz", "utmctr");
            scs_update_formfields_cookie(formObj.form, formObj.gClickID, "__utmzz", "gclid");
            scs_update_formfields_cookie(formObj.form, formObj.dClickID, "__utmzz", "dclid");
        }
    }
}

/* Update a gravity form field with values from a cookie */
function scs_update_formfields_cookie(formID, inputID, cookieName, cookieVariable = ""){
    var tempField = "#input_" + formID + "_" + inputID;
    if (jQuery(tempField).length)
    {
        var tempVariable = scs_getCookieByName(cookieName, cookieVariable);
        jQuery(tempField).val(tempVariable);
    }
}

/* Get a cookie value given the name */
function scs_getCookieByName(cookieName, variableName = ""){
    var scsCookie = document.cookie.match('(^|;) ?' + cookieName + '=([^;]*)(;|$)');
    scsCookie = scsCookie ? scsCookie[2] : null;
    // Decode cookie string
    scsCookie = decodeURIComponent(scsCookie);
    var returnValue = null;
    if (scsCookie.indexOf("|") > -1)
    {
        // Split cookie into Array
        var scsCookieArray = scsCookie.split("|");
        for (var i=0; i < scsCookieArray.length; i++)
        {
            if (scsCookieArray[i].indexOf(variableName) > -1)
            {
                // we need to extract the variable value
                returnValue = scsCookieArray[i].slice(7);
            }
        }
    }
    else
    {
        returnValue = scsCookie;
    }
    return returnValue;
}